import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowRight, Search } from 'lucide-react';
import { openBookingModal } from '../components/BookingModal';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <div className="not-found-content">
        <div className="not-found-icon">
          <Search className="w-16 h-16" />
        </div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-actions">
          <Link to="/" className="btn-gradient">
            <Home className="w-5 h-5" />
            Back to Home
          </Link>
          <button onClick={openBookingModal} className="btn-outline-dark">
            Book a Growth Call
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
        <div className="not-found-links">
          <p>Or check out these pages:</p>
          <div className="quick-links">
            <Link to="/features">Features</Link>
            <Link to="/workflows">Workflows</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/how-it-works">How It Works</Link>
          </div>
        </div>
      </div>

      <style>{`
        .not-found-page {
          min-height: calc(100vh - 200px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 80px 24px;
          background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
        }
        
        .not-found-content {
          text-align: center;
          max-width: 500px;
        }
        
        .not-found-icon {
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
          background: linear-gradient(135deg, rgba(255, 27, 158, 0.1), rgba(0, 217, 255, 0.1));
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--pink);
        }
        
        .not-found-content h1 {
          font-family: 'Outfit', sans-serif;
          font-size: 120px;
          font-weight: 800;
          background: linear-gradient(135deg, #FF1B9E, #9945FF, #00D9FF);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          line-height: 1;
          margin-bottom: 8px;
        }
        
        .not-found-content h2 {
          font-family: 'Outfit', sans-serif;
          font-size: 28px;
          font-weight: 700;
          color: var(--text);
          margin-bottom: 12px;
        }
        
        .not-found-content > p {
          color: var(--mid);
          font-size: 16px;
          margin-bottom: 32px;
        }
        
        .not-found-actions {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
          margin-bottom: 40px;
        }
        
        .not-found-actions a {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          border-radius: 980px;
          font-weight: 600;
          font-size: 15px;
          text-decoration: none;
          transition: all 0.3s ease;
        }
        
        .not-found-actions .btn-gradient {
          background: linear-gradient(135deg, #FF1B9E, #9945FF);
          color: #fff;
        }
        
        .not-found-actions .btn-gradient:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(255, 27, 158, 0.3);
        }
        
        .not-found-actions .btn-outline-dark {
          background: transparent;
          color: var(--text);
          border: 2px solid var(--border);
        }
        
        .not-found-actions .btn-outline-dark:hover {
          border-color: var(--pink);
          color: var(--pink);
        }
        
        .not-found-links p {
          color: var(--soft);
          font-size: 14px;
          margin-bottom: 16px;
        }
        
        .quick-links {
          display: flex;
          gap: 24px;
          justify-content: center;
          flex-wrap: wrap;
        }
        
        .quick-links a {
          color: var(--pink);
          text-decoration: none;
          font-weight: 500;
          font-size: 14px;
          transition: opacity 0.2s;
        }
        
        .quick-links a:hover {
          opacity: 0.7;
        }
        
        @media (max-width: 600px) {
          .not-found-content h1 {
            font-size: 80px;
          }
          
          .not-found-content h2 {
            font-size: 24px;
          }
          
          .not-found-actions {
            flex-direction: column;
            align-items: center;
          }
          
          .not-found-actions a {
            width: 100%;
            justify-content: center;
          }
          
          .quick-links {
            gap: 16px;
          }
        }
      `}</style>
    </div>
  );
};

export default NotFound;
